// src/layout/Header.js
import React, { useState, useEffect } from 'react';
import {
    FaUserCircle, FaCog, FaCalculator, FaRobot,
    FaPrint, FaFile, FaTh, FaMagic, FaSlidersH, FaWrench, FaListAlt, FaTint,
    FaUserCog,
    FaDatabase, FaFileDownload, FaHistory, FaKey, FaLock,
    FaChevronDown, FaChevronRight, FaQuestionCircle,
    FaUser, FaCreditCard, FaSignOutAlt, FaBars, FaTimes,
    FaCogs, FaClipboardList, FaVial, FaStore,
    FaTag, FaBoxOpen, FaInbox, FaExternalLinkAlt
} from 'react-icons/fa';
import { getProfile } from '../services/profileApi';
import { Dropdown } from 'react-bootstrap';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import HeaderMenu from './HeaderMenu';
import NotificheDropdown from '../../src/layout/NotificheDropdown';
import { hasRuolo, getRuolo, getCurrentUser } from '../hooks/useCurrentUser';
import { usePermessi } from '../context/PermessiContext';
import { useTranslation } from 'react-i18next';

const nl = (to, icon, label) => (
    <li key={to + label}>
        <NavLink to={to} className={({ isActive }) => isActive ? 'page-link sidebar-nav-active' : 'page-link'}>
            {icon} {label}
        </NavLink>
    </li>
);

const ConfigurazioneSidebarContent = () => {
    const { t } = useTranslation();
    const [openAvanzate, setOpenAvanzate] = useState(false);

    const toggleStyle = {
        cursor: 'pointer',
        userSelect: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    };

    return (
        <>
            <ul className="list-unstyled">
                <h5>{t('nav.large_format')}</h5>
                {nl('/grande-formato/stampanti',              <FaPrint     className="me-2 text-secondary" />, t('nav.print_machines'))}
                {nl('/grande-formato/formati',                <FaFile      className="me-2 text-secondary" />, t('nav.sheet_formats'))}
                {nl('/grande-formato/supporti',               <FaTh        className="me-2 text-secondary" />, t('nav.supports'))}
                {nl('/grande-formato/finiture',               <FaMagic     className="me-2 text-secondary" />, t('nav.finishes'))}
                {nl('/grande-formato/parametri',              <FaSlidersH  className="me-2 text-secondary" />, t('nav.parameters'))}
                {nl('/grande-formato/lavorazioni-accessorie', <FaWrench    className="me-2 text-secondary" />, t('nav.accessory_operations'))}
                {nl('/grande-formato/regole',                 <FaListAlt   className="me-2 text-secondary" />, t('nav.rules'))}
                {nl('/grande-formato/inchiostri',             <FaTint      className="me-2 text-secondary" />, t('nav.inks'))}
            </ul>
            <ul className="list-unstyled">
                <h5>{t('nav.small_format')}</h5>
                {nl('/piccolo-formato/stampanti',              <FaPrint    className="me-2 text-secondary" />, t('nav.print_machines'))}
                {nl('/piccolo-formato/formati',                <FaFile     className="me-2 text-secondary" />, t('nav.sheet_formats'))}
                {nl('/piccolo-formato/supporti',               <FaTh       className="me-2 text-secondary" />, t('nav.supports'))}
                {nl('/piccolo-formato/finiture',               <FaMagic    className="me-2 text-secondary" />, t('nav.finishes'))}
                {nl('/piccolo-formato/parametri',              <FaSlidersH className="me-2 text-secondary" />, t('nav.parameters'))}
                {nl('/piccolo-formato/lavorazioni-accessorie', <FaWrench   className="me-2 text-secondary" />, t('nav.accessory_operations'))}
                {nl('/piccolo-formato/regole',                 <FaListAlt  className="me-2 text-secondary" />, t('nav.rules'))}
                {nl('/piccolo-formato/inchiostri',             <FaTint     className="me-2 text-secondary" />, t('nav.inks'))}
            </ul>
            <ul className="list-unstyled">
                <h5>{t('nav.operators_section')}</h5>
                {nl('/operatori', <FaUserCog className="me-2 text-secondary" />, t('nav.manage_operators'))}
                {nl('/workflow-template', <FaListAlt className="me-2 text-secondary" />, t('nav.workflows'))}
            </ul>

            {/* ── Personalizzazioni globali ── */}
            <ul className="list-unstyled">
                <h5>{t('nav.customizations_section')}</h5>
                {nl('/personalizzazioni', <FaCog className="me-2 text-secondary" />, t('nav.global'))}
            </ul>

            {/* ── Avanzate (collassabile) ── */}
            <ul className="list-unstyled">
                <h5 style={toggleStyle} onClick={() => setOpenAvanzate(o => !o)}>
                    <span>{t('nav.advanced_section')}</span>
                    {openAvanzate ? <FaChevronDown size={11} className="text-muted" /> : <FaChevronRight size={11} className="text-muted" />}
                </h5>
                {openAvanzate && (
                    <>
                        {nl('/backup',                    <FaDatabase    className="me-2 text-secondary" />, t('nav.backup'))}
                        {nl('/esportazione',              <FaFileDownload className="me-2 text-secondary" />, t('nav.csv_export'))}
                        {nl('/log-attivita',              <FaHistory     className="me-2 text-secondary" />, t('nav.activity_log'))}
                        {nl('/connettori',                <FaKey         className="me-2 text-secondary" />, t('nav.api_keys'))}
                        {nl('/ruoli',                     <FaLock        className="me-2 text-secondary" />, t('nav.roles'))}
                        {nl('/configurazione/ai',         <FaRobot       className="me-2 text-primary"   />, t('nav.ai_features'))}
                    </>
                )}
            </ul>
        </>
    );
};

const Header = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const ruolo = getRuolo();
    const { hasPermesso } = usePermessi();
    const currentUser = getCurrentUser();
    const [nomeCompleto, setNomeCompleto] = React.useState(
        [currentUser?.nome, currentUser?.cognome].filter(Boolean).join(' ') || ''
    );
    const [mobileNavOpen, setMobileNavOpen] = useState(false);
    const [shopSlug, setShopSlug] = useState('');
    const [richiesteShopCount, setRichiesteShopCount] = useState(0);

    useEffect(() => {
        getProfile().then(data => {
            if (data.shop_attivo && data.shop_slug) {
                setShopSlug(data.shop_slug.trim());
            }
        }).catch(() => {});
    }, []);

    useEffect(() => {
        const carica = () => {
            import('../services/shopAdminApi')
                .then(({ getRichiesteCount }) => getRichiesteCount())
                .then(data => setRichiesteShopCount(data.count || 0))
                .catch(() => {});
        };
        carica();
        const timer = setInterval(carica, 60_000);
        return () => clearInterval(timer);
    }, []);

    React.useEffect(() => {
        if (nomeCompleto) return;
        const token = localStorage.getItem('token');
        if (!token) return;
        fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:3001'}/api/me`, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then(r => r.ok ? r.json() : null)
            .then(data => {
                if (data) setNomeCompleto([data.nome, data.cognome].filter(Boolean).join(' ') || '');
            })
            .catch(() => {});
    }, [nomeCompleto]);

    const pathname = location.pathname;

    const formato =
        pathname.startsWith('/dashboard') ? 'dashboard'
            : pathname.startsWith('/piccolo-formato') ? 'piccolo'
                : pathname.startsWith('/grande-formato') ? 'grande'
                    : pathname.startsWith('/preventivatore') ? 'preventivatore'
                        : '';

    const hideHeaderMenuRoutes = [
        '/dashboard',
        '/ordini',
        '/preventivi',
        '/catalogo',
        '/listini',
        '/clienti',
        '/fatturazioni',
        '/preventivatore',
    ];

    const shouldShowHeaderMenu = !hideHeaderMenuRoutes.some(route => pathname.startsWith(route));

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.dispatchEvent(new Event('auth-changed'));
        navigate('/login', { replace: true });
    };

    const handleEditProfile      = () => navigate('/profilo');
    const handleEditSubscription = () => navigate('/abbonamento');

    const openRightSidebar = () => {
        const event = new CustomEvent('openRightSidebar', {
            detail: {
                title: t('nav.configuration'),
                content: <ConfigurazioneSidebarContent key={Date.now()} />
            }
        });
        window.dispatchEvent(event);
    };

    const navLinkClass = (active) =>
        `btn btn-sm me-1 ${active ? 'btn-dark' : 'btn-light'}`;

    const mobileNavLinkClass = (active) =>
        `btn btn-sm mb-1 me-1 ${active ? 'btn-dark' : 'btn-light'}`;

    return (
        <div className="header-wrapper">
            <div className="topHeader px-3 px-md-4 py-2 d-flex align-items-center justify-content-between">
                {/* ── Sinistra: logo + nav desktop ── */}
                <div className="d-flex align-items-center overflow-hidden">
                    <div className="fw-bold me-3 me-md-4 text-nowrap">PSC Print Service Control</div>

                    {/* Nav principale — visibile solo da md in su */}
                    <div className="d-none d-md-flex flex-wrap">
                        <NavLink to="/dashboard" className={navLinkClass(formato === 'dashboard')}>
                            {t('nav.dashboard')}
                        </NavLink>
                        {hasPermesso('clienti') && (
                            <NavLink to="/clienti" className={navLinkClass(pathname.startsWith('/clienti'))}>
                                {t('nav.clients')}
                            </NavLink>
                        )}
                        {hasPermesso('preventivi') && (
                            <NavLink to="/preventivi" className={navLinkClass(pathname.startsWith('/preventivi'))}>
                                {t('nav.quotes')}
                            </NavLink>
                        )}
                        {hasPermesso('ordini') && (
                            <NavLink to="/ordini" className={navLinkClass(pathname.startsWith('/ordini'))}>
                                {t('nav.orders')}
                            </NavLink>
                        )}
                        {hasPermesso('produzione') && (
                            <NavLink to="/produzione" className={navLinkClass(pathname.startsWith('/produzione'))}>
                                {t('nav.production')}
                            </NavLink>
                        )}
                        {hasPermesso('magazzino') && (
                            <NavLink to="/magazzino" className={navLinkClass(pathname.startsWith('/magazzino'))}>
                                {t('nav.warehouse')}
                            </NavLink>
                        )}
                        {hasPermesso('listini') && (
                            <NavLink to="/listini" className={navLinkClass(pathname.startsWith('/listini'))}>
                                {t('nav.price_lists')}
                            </NavLink>
                        )}
                        {hasPermesso('fatturazioni') && (
                            <NavLink to="/fatturazioni" className={navLinkClass(pathname.startsWith('/fatturazioni'))}>
                                {t('nav.invoicing')}
                            </NavLink>
                        )}
                        {hasPermesso('statistiche') && (
                            <NavLink to="/statistiche" className={navLinkClass(pathname.startsWith('/statistiche'))}>
                                {t('nav.statistics')}
                            </NavLink>
                        )}
                    </div>
                </div>

                {/* ── Destra: azioni ── */}
                <div className="d-flex align-items-center gap-2 flex-shrink-0 ms-2">
                    {hasPermesso('preventivatore') && (
                        <Dropdown align="end">
                            <Dropdown.Toggle
                                variant="light"
                                size="sm"
                                className={`btn-icon-only ${pathname.startsWith('/preventivatore') ? 'active' : ''}`}
                                title="Preventivatore"
                            >
                                <FaCalculator size={18} />
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Header style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.07em' }}>
                                    Preventivatore
                                </Dropdown.Header>
                                <Dropdown.Item active={pathname.startsWith('/preventivatore/configuratore')} onClick={() => navigate('/preventivatore/configuratore')} className="d-flex align-items-center">
                                    <FaCogs className="me-2 text-secondary" size={14} />
                                    {t('nav.configuratore')}
                                </Dropdown.Item>
                                <Dropdown.Item active={pathname.startsWith('/preventivatore/categorie')} onClick={() => navigate('/preventivatore/categorie')} className="d-flex align-items-center">
                                    <FaTh className="me-2 text-secondary" size={14} />
                                    {t('nav.categorie')}
                                </Dropdown.Item>
                                <Dropdown.Item active={pathname.startsWith('/preventivatore/template')} onClick={() => navigate('/preventivatore/template')} className="d-flex align-items-center">
                                    <FaClipboardList className="me-2 text-secondary" size={14} />
                                    {t('nav.template')}
                                </Dropdown.Item>
                                <Dropdown.Divider />
                                <Dropdown.Item active={pathname.startsWith('/preventivatore/calcolatore')} onClick={() => navigate('/preventivatore/calcolatore')} className="d-flex align-items-center">
                                    <FaCalculator className="me-2 text-secondary" size={14} />
                                    {t('nav.calcolatore')}
                                </Dropdown.Item>
                                <Dropdown.Item active={pathname.startsWith('/preventivatore/simulatore')} onClick={() => navigate('/preventivatore/simulatore')} className="d-flex align-items-center">
                                    <FaVial className="me-2 text-secondary" size={14} />
                                    {t('nav.simulatore')}
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    )}

                    {hasRuolo('admin', 'tecnico') && (
                        <button className="btn btn-sm btn-light" onClick={openRightSidebar} title="Configurazione">
                            <FaCog size={18} />
                        </button>
                    )}

                    {/* Shop dropdown — nel container destro, funziona senza override Popper */}
                    <Dropdown className="me-1">
                        <Dropdown.Toggle
                            className={`btn btn-sm ${pathname.startsWith('/shop') || pathname.startsWith('/negozio') ? 'btn-dark' : 'btn-light'} d-inline-flex align-items-center gap-1 position-relative`}
                            id="shop-dropdown"
                        >
                            <FaStore size={18} />
                            <span>Shop</span>
                            {richiesteShopCount > 0 && (
                                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style={{ fontSize: '0.6rem' }}>
                                    {richiesteShopCount > 99 ? '99+' : richiesteShopCount}
                                </span>
                            )}
                        </Dropdown.Toggle>
                        <Dropdown.Menu align="end">
                            <Dropdown.Header>Gestione negozio</Dropdown.Header>
                            <Dropdown.Item onClick={() => navigate('/negozio')}>
                                <FaStore size={12} className="me-2 text-muted" />
                                Dati negozio
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => navigate('/shop/prodotti')}>
                                <FaBoxOpen size={12} className="me-2 text-muted" />
                                Prodotti
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => navigate('/shop/categorie')}>
                                <FaTag size={12} className="me-2 text-muted" />
                                Categorie
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => navigate('/shop/richieste')} className="d-flex align-items-center justify-content-between">
                                <span>
                                    <FaInbox size={12} className="me-2 text-muted" />
                                    Richieste
                                </span>
                                {richiesteShopCount > 0 && (
                                    <span className="badge bg-danger rounded-pill" style={{ fontSize: '0.65rem' }}>
                                        {richiesteShopCount}
                                    </span>
                                )}
                            </Dropdown.Item>
                            {shopSlug && (
                                <>
                                    <Dropdown.Divider />
                                    <Dropdown.Item
                                        href={process.env.NODE_ENV === 'development'
                                            ? `http://localhost:4200/${shopSlug}`
                                            : `https://shop.pscprint.com/${shopSlug}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="d-flex align-items-center gap-2 text-success"
                                    >
                                        <FaExternalLinkAlt size={11} />
                                        Apri vetrina pubblica
                                    </Dropdown.Item>
                                </>
                            )}
                        </Dropdown.Menu>
                    </Dropdown>

                    <NotificheDropdown />

                    <Dropdown align="end">
                        <Dropdown.Toggle className="d-flex align-items-center btn-light profileButtonCont">
                            <FaUserCircle className="me-2 flex-shrink-0" size={18} />
                            <span className="d-none d-md-inline text-start lh-1">
                                <span className="d-block" style={{ fontSize: 13, fontWeight: 600 }}>{nomeCompleto}</span>
                                <span className="d-block text-muted" style={{ fontSize: 11 }}>{ruolo}</span>
                            </span>
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item active={pathname.startsWith('/profilo')} onClick={handleEditProfile} className="d-flex align-items-center">
                                <FaUser className="me-2 text-secondary" size={14} />
                                {t('nav.edit_profile')}
                            </Dropdown.Item>
                            {process.env.NODE_ENV !== 'production' && hasRuolo('admin') && (
                                <>
                                    <Dropdown.Divider />
                                    <Dropdown.Item active={pathname.startsWith('/abbonamento')} onClick={handleEditSubscription} className="d-flex align-items-center">
                                        <FaCreditCard className="me-2 text-secondary" size={14} />
                                        {t('nav.subscription')}
                                    </Dropdown.Item>
                                </>
                            )}
                            <Dropdown.Divider />
                            <Dropdown.Item active={pathname.startsWith('/help')} onClick={() => navigate('/help')} className="d-flex align-items-center">
                                <FaQuestionCircle className="me-2 text-secondary" size={14} />
                                {t('nav.help')}
                            </Dropdown.Item>
                            <Dropdown.Divider />
                            <Dropdown.Item onClick={handleLogout} className="d-flex align-items-center">
                                <FaSignOutAlt className="me-2 text-secondary" size={14} />
                                {t('nav.logout')}
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>

                    {/* Hamburger — visibile solo su mobile */}
                    <button
                        className="btn btn-sm btn-light d-md-none"
                        onClick={() => setMobileNavOpen(o => !o)}
                        aria-label="Menu"
                    >
                        {mobileNavOpen ? <FaTimes size={16} /> : <FaBars size={16} />}
                    </button>
                </div>
            </div>

            {/* ── Nav mobile collassabile ── */}
            {mobileNavOpen && (
                <div className="d-md-none bg-light border-top px-3 py-2">
                    <NavLink
                        to="/dashboard"
                        className={mobileNavLinkClass(formato === 'dashboard')}
                        onClick={() => setMobileNavOpen(false)}
                    >
                        {t('nav.dashboard')}
                    </NavLink>
                    {hasPermesso('clienti') && (
                        <NavLink
                            to="/clienti"
                            className={mobileNavLinkClass(pathname.startsWith('/clienti'))}
                            onClick={() => setMobileNavOpen(false)}
                        >
                            {t('nav.clients')}
                        </NavLink>
                    )}
                    {hasPermesso('preventivi') && (
                        <NavLink
                            to="/preventivi"
                            className={mobileNavLinkClass(pathname.startsWith('/preventivi'))}
                            onClick={() => setMobileNavOpen(false)}
                        >
                            {t('nav.quotes')}
                        </NavLink>
                    )}
                    {hasPermesso('ordini') && (
                        <NavLink
                            to="/ordini"
                            className={mobileNavLinkClass(pathname.startsWith('/ordini'))}
                            onClick={() => setMobileNavOpen(false)}
                        >
                            {t('nav.orders')}
                        </NavLink>
                    )}
                    {hasPermesso('produzione') && (
                        <NavLink
                            to="/produzione"
                            className={mobileNavLinkClass(pathname.startsWith('/produzione'))}
                            onClick={() => setMobileNavOpen(false)}
                        >
                            {t('nav.production')}
                        </NavLink>
                    )}
                    {hasPermesso('magazzino') && (
                        <NavLink
                            to="/magazzino"
                            className={mobileNavLinkClass(pathname.startsWith('/magazzino'))}
                            onClick={() => setMobileNavOpen(false)}
                        >
                            {t('nav.warehouse')}
                        </NavLink>
                    )}
                    {hasPermesso('listini') && (
                        <NavLink
                            to="/listini"
                            className={mobileNavLinkClass(pathname.startsWith('/listini'))}
                            onClick={() => setMobileNavOpen(false)}
                        >
                            {t('nav.price_lists')}
                        </NavLink>
                    )}
                    {hasPermesso('fatturazioni') && (
                        <NavLink
                            to="/fatturazioni"
                            className={mobileNavLinkClass(pathname.startsWith('/fatturazioni'))}
                            onClick={() => setMobileNavOpen(false)}
                        >
                            {t('nav.invoicing')}
                        </NavLink>
                    )}
                    {hasPermesso('statistiche') && (
                        <NavLink
                            to="/statistiche"
                            className={mobileNavLinkClass(pathname.startsWith('/statistiche'))}
                            onClick={() => setMobileNavOpen(false)}
                        >
                            {t('nav.statistics')}
                        </NavLink>
                    )}
                </div>
            )}

            {shouldShowHeaderMenu && <HeaderMenu formato={formato} />}
        </div>
    );
};

export default Header;